import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class MeteredModalDrive23 extends Widget {
	largeContent = {
		1: {
			title: "Built To Fight The Flood",
			text: (
				<div>
					<p>
						“The Democrats don’t matter. The real opposition is the media,”
						Steve Bannon told Michael Lewis in 2018. “And the way to deal with
						them is to flood the zone with shit.” It was a classic example of
						saying the quiet part out loud: an acknowledgement of a right-wing
						strategy that TPM has understood for over 20 years. 
					</p>

					<p>
						We understand it because in many ways we were built to counteract
						it. Long before mainstream outlets were struggling with whether to
						take Trump’s presidential prospects seriously, or had reporters on
						the QAnon beat, or did profiles of Nazis in America’s heartland, TPM
						was obsessively reporting on what many still considered to be the
						fringe of the Republican Party. 
					</p>

					<p>
						Now the fringe has gone mainstream, and the big news outlets are
						forced to pay attention. But while they struggle to learn the
						right-wing playbook, we’re going to keep taking it apart, exposing
						the strategy behind the flood, and identifying the shit that’s
						flooding the zone for what it is: shit. Join us!
					</p>
				</div>
			),
			imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/bannon-flood.png`,
		},
		2: {
			title: "Small Team. Big Results.",
			text: (
				<div>
					<p>
						Last December, TPM’s five reporters and three editors (really, we’re
						that small!) published the{" "}
						<a href="https://talkingpointsmemo.com/meadows-texts">
							Meadows Texts
						</a>
						, a blockbuster series which analyzed the 2,319 text messages that
						former White House Chief of Staff Mark Meadows provided to the House
						Jan. 6 select committee. The series was groundbreaking, and exposed
						the depth of the involvement of 34 members of Congress, other
						government officials, and influential political figures in a scheme
						to overturn the 2020 election.
					</p>

					<p>
						We knew we had something big, but the impact of our reporting
						exceeded our expectations.{" "}
						<a href="https://www.penncapital-star.com/blog/pa-u-s-rep-scott-perry-among-lawmakers-on-text-chain-about-efforts-to-overturn-2020-election/">
							Local
						</a>{" "}
						<a href="https://www.al.com/politics/2022/12/mo-brooks-reportedly-described-as-ringleader-of-effort-to-overturn-election-in-mark-meadows-texts.html">
							news
						</a>{" "}
						<a href="https://www.postandcourier.com/politics/scs-ralph-norman-faces-calls-to-resign-over-martial-law-text-message-to-mark-meadows/article_95c38b86-7b20-11ed-8bee-cbd0e3aaf205.html">
							outlets
						</a>{" "}
						across the country seized upon TPM’s stories, and many pressed their
						local lawmakers for more information. Members of Congress were
						forced to respond. The series also prompted coverage in{" "}
						<a href="https://www.theatlantic.com/ideas/archive/2022/12/threat-democracy-still-congress/672447/">
							national
						</a>{" "}
						<a href="https://www.nbcnews.com/meet-the-press/first-read/jan-6-continues-stain-gop-text-messages-show-rcna61643">
							outlets
						</a>
						,{" "}
						<a href="https://www.nytimes.com/2022/12/14/arts/television/stephen-colbert-mark-meadows.html">
							jokes by late-night hosts
						</a>
						, and a response from the White House, which{" "}
						<a href="https://talkingpointsmemo.com/news/white-house-norman-martial-law">
							condemned
						</a>{" "}
						Rep. Norman’s{" "}
						<a href="https://talkingpointsmemo.com/news/norman-responds-to-tpm-revelations-of-his-call-for-marshall-law-texts-came-from-source-of-frustration">
							call for "marshall" law
						</a>
						. We’re proud of what our small newsroom accomplished, and it’s not
						hyperbole when we say that, without our members, none of this would
						have been possible. Join us!
					</p>
				</div>
			),
			imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/meadows-texts-big-results.png`,
		},
		3: {
			title: (
				<span>
					What <i>They</i> Can't Be
				</span>
			),
			text: (
				<div>
					<p>
						When one of the big political insider publications recently{" "}
						<a href="https://talkingpointsmemo.com/news/ben-montgomery-ron-desantis">
							fired a reporter
						</a>{" "}
						for standing up to Ron DeSantis’ PR machine, it showed a downside, a
						civic Achilles heel, of a publication whose business model is built
						on access coupled with purported partisan neutrality. It also showed
						why it’s so important that truly independent news organizations like
						TPM exist. We don’t have to jump when anyone tells us to. We’re not
						tied to the broader corporate strategy of a parent company which can
						change suddenly for reasons with no connections to political news.
						Our total focus is poring over the entrails of the political moment,
						figuring out which stories matter and doing all we can to try to
						drive them forward. We genuinely don’t care if some politician or
						oligarch lands a virtual sucker punch on one of our reporters. We
						don’t have to care what anyone says about us. We have one core rule
						that governs all of our work – fundamental honesty with readers.
					</p>

					<p>
						Big outfits can do things we can’t. That’s never lost on us. But we
						can be things they can’t. Join us!
					</p>
				</div>
			),
			imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-newspaper.png`,
		},
	};

	componentWillMount() {
		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);
		//we DO want to count the first and current article view, but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy, lets increment the views to account for that
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			views = views + 1;
		}
		let version = !this.isFp && views > 3 ? "large" : "small";

		//if this cookie exists they've seen the FinalPitchDrive23
		// and dismissed it. from that point they only get the small bumper
		let dismissedFinalPitch = !!getCookie("tpm_dismiss_final_pitch"); //might be '1', might be null, cast to bool
		if (dismissedFinalPitch) version = "small";

		this.state.version = version;
		this.state.views = views;
		this.state.closed = views < 0;
		this.state.hide = views > 9 && !dismissedFinalPitch && !this.isFp;
		if (this.state.hide) return;

		if (version === "large") {
			const cookieName = "tpm_MeteredModalDrive23_largeIndex";
			const largeIndex = getCookie(cookieName);
			const i = parseInt(largeIndex);

			if (largeIndex === null || i >= 3) {
				//first view or 4th+ view, set to 1
				this.largeIndex = 1;
				setCookie(cookieName, 1, 30);
			} else {
				//increment
				this.largeIndex = i + 1;
				setCookie(cookieName, i + 1, 30);
			}
			document.querySelector("body").classList.add("modal-overlay-open");
		}

		//bind event handlers
		this.toggleClosed = this.toggleClosed.bind(this);
		this.toggleVersion = this.toggleVersion.bind(this);
	}

	toggleClosed() {
		this.setState({ closed: !this.state.closed });
	}

	toggleVersion(v = "small") {
		this.setState({ version: v }, () => {
			if (this.state.version === "large") {
				document.querySelector("body").classList.add("modal-overlay-open");
			} else {
				document.querySelector("body").classList.remove("modal-overlay-open");
			}
		});
	}

	get largeVersionName() {
		return ["flood", "results", "bigs"][this.largeIndex - 1];
	}

	get discountAmt() {
		if (this.state.views > 9) return "50%";
		else return "25%";
	}

	get isMobile() {
		return this.props.device === "mobile";
	}

	get isFp() {
		return this.props.fp;
	}

	get largeHref() {
		let content = ["flood", "results", "bigs"][this.largeIndex - 1];
		return `${document.location.origin}/memberships?utm_source=on+site&utm_medium=modal&utm_campaign=2023+membership+drive&utm_content=${content}`;
	}

	get smallHref() {
		let content = this.isFp ? "frontpage" : "article";
		return `${document.location.origin}/memberships?utm_source=on+site&utm_medium=bumper&utm_campaign=2023+membership+drive&utm_content=${content}`;
	}

	getLargeContent(i) {
		return this.largeContent[i];
	}

	renderContent() {
		if (this.state.hide) return;
		if (this.state.version === "large") return this.renderLarge();
		if (this.state.version === "small") return this.renderSmall();
		return this.renderBadge();
	}

	get viewCount() {
		const views = this.state.views;
		return `You've read ${views} article${views > 1 ? "s" : ""} this month`;
	}

	renderBadge() {
		return (
			<div
				class={`MeteredModalDrive23__Fixed --badge ${this.isFp ? "--fp" : ""}`}
			>
				<div
					class={`MeteredModalDrive23__Inner --badge ${
						this.isFp ? "--fp" : ""
					}`}
					onClick={(event) => {
						event.stopPropagation();
						this.toggleVersion("small");
					}}
				>
					<img
						class="MeteredModalDrive23__Image"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-membership-drive-badge-250.png`}
						alt="TPM's Annual Membership Drive"
					/>
				</div>
			</div>
		);
	}

	renderSmall() {
		return (
			<div
				class={`MeteredModalDrive23__Fixed --small ${this.isFp ? "--fp" : ""}`}
			>
				<div
					class={`MeteredModalDrive23__Inner --small ${
						this.isFp ? "--fp" : ""
					}`}
				>
					<img
						class="MeteredModalDrive23__Image"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-membership-drive-badge-250.png`}
						alt="TPM's Annual Membership Drive"
					/>

					<div class="MeteredModalDrive23__Right">
						<div
							className="MeteredModalDrive23__Close"
							onClick={(event) => {
								event.stopPropagation();
								this.toggleVersion("badge");
							}}
						>
							<i class="fa-light fa-xmark"></i>
						</div>
						<div class="MeteredModalDrive23__Count">{this.viewCount}</div>
						<a
							class="MeteredModalDrive23__Button Button --red --full-width"
							href={this.smallHref}
						>
							Get {this.discountAmt} off any TPM membership
						</a>
						<div class="MeteredModalDrive23__Link">
							<a href={this.smallHref}>
								Get {this.discountAmt} off any TPM membership
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderLarge() {
		if (this.isFP) return;
		const content = this.getLargeContent(this.largeIndex);
		return (
			<div class="MeteredModalDrive23__Large">
				<div class="MeteredModalDrive23__LargeOuter">
					<div class="MeteredModalDrive23__LargeHeader">
						<div className="container">
							<div className="row">
								<div className="--span-12">
									<div class="MeteredModalDrive23__Flex --between">
										<img
											class="MeteredModalDrive23__LargeImage"
											src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-membership-drive-badge-550.png`}
											alt="TPM's Annual Membership Drive"
										/>
										<div class="MeteredModalDrive23__LargeCount">
											{this.viewCount}
										</div>
										<a
											href={`${document.location.origin}/signin`}
											class="MeteredModalDrive23__LargeSignIn"
										>
											Already a member? SIGN IN
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="MeteredModalDrive23__LargeInner">
						<div class="container">
							<div className="MeteredModalDrive23__Flex --between --gap-16 --column-md">
								<div className="MeteredModalDrive23__LargeContentLeft">
									<img
										class="MeteredModalDrive23__LargeContentImage --visible-md"
										src={content.imgSrc}
										alt="alt text"
									/>
									<div className="MeteredModalDrive23__LargeTitle">
										{content.title}
									</div>
									<div className="MeteredModalDrive23__Text">
										{content.text}
									</div>
									<div className="MeteredModalDrive23__LargeCTAs --desktop">
										<div className="MeteredModalDrive23__Flex --center-both --gap-16 --column">
											<a
												class="MeteredModalDrive23__Button Button --red"
												href={this.largeHref}
											>
												Get {this.discountAmt} off any TPM membership
											</a>

											<div
												class="MeteredModalDrive23__LargeClose"
												onClick={() => {
													this.toggleVersion("small");
												}}
											>
												No thanks
											</div>
										</div>
									</div>
								</div>
								<div className={`MeteredModalDrive23__LargeContentRight`}>
									<img
										class={`MeteredModalDrive23__LargeContentImage --hidden-md ${
											this.largeVersionName === "bigs" ? "--bigs" : ""
										}`}
										src={content.imgSrc}
										alt="alt text"
									/>
									<div className="MeteredModalDrive23__LargeCTAs">
										<div className="MeteredModalDrive23__Flex --center-both --column">
											<a
												class="MeteredModalDrive23__Button --large Button --red"
												href={this.largeHref}
											>
												Get {this.discountAmt} off any TPM membership
											</a>

											<div
												class="MeteredModalDrive23__LargeClose"
												onClick={() => {
													this.toggleVersion("small");
												}}
											>
												No thanks
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
